export default __webpack_public_path__ + "static/media/user.432d5d40.png";